/* eslint-disable */
import request from '@/utils/request'
import { APICore } from '@/utils/servicesApi'
const qs = require('qs')


export function readAll() {
  return request({
    url: APICore() + '/omni/room/read-all',
    method: 'POST',
  })
}

export function resolveAll() {
  return request({
    url: APICore() + '/omni/room/resolve-all',
    method: 'POST',
  })
}

export function numUnread(data) {
  return request({
    url: APICore() + '/omni/room/num-unread',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}
export function licenseByAgent(agentId) {
  return request({
    url: APICore() + '/omni/license-by-agent?agent_id=' + agentId,
    method: 'GET',
  })
}

export function setResolve(roomId) {
  return request({
    url: APICore() + '/omni/room/set-resolve?room_id=' + roomId,
    method: 'GET',
  })
}
export function isNotResolve(roomId) {
  return request({
    url: APICore() + '/omni/room/isnotresolve?room_id=' + roomId,
    method: 'GET',
  })
}
export function getRoomList(data) {
  return request({
    url: APICore() + '/omni/room/room-list',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}
export function getHotChatList(data) {
  return request({
    url: APICore() + '/omni/room/hot-chat-list',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}

export function getColdChatList(data) {
  return request({
    url: APICore() + '/omni/room/cold-chat-list',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}


// WEBPACK FOOTER //
// ./src/api/omniroom.js